import React from 'react';
import { Dialog } from '@mui/material';
import './ResetTemplateConfirmDialog.css';

const ResetTemplateConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  saving = false
}) => (
  <Dialog
    open={open}
    onClose={saving ? undefined : onClose}
    maxWidth="xs"
    fullWidth
    PaperProps={{ className: 'reset-template-confirm__paper' }}
  >
    <div className="reset-template-confirm">
      <div className="reset-template-confirm__body">
        <div className="reset-template-confirm__header">
          <h2 className="reset-template-confirm__title">Reset this template?</h2>
          <button
            type="button"
            className="reset-template-confirm__close"
            onClick={onClose}
            disabled={saving}
            aria-label="Close reset confirmation dialog"
          >
            ×
          </button>
        </div>

        <p className="reset-template-confirm__subtitle">
          This will restore the default subject and body for <strong>{title}</strong> and save it immediately.
        </p>

        <div className="reset-template-confirm__summary">
          <span className="reset-template-confirm__label">What stays the same</span>
          <p className="reset-template-confirm__value">This keeps the template enabled and ready to send.</p>
        </div>

        <div className="reset-template-confirm__summary reset-template-confirm__summary--warning">
          <span className="reset-template-confirm__label">What changes</span>
          <p className="reset-template-confirm__value">Any custom subject line or body content will be replaced by the saved default template.</p>
        </div>
      </div>

      <div className="reset-template-confirm__actions">
        <button
          type="button"
          className="reset-template-confirm__button reset-template-confirm__button--secondary"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          type="button"
          className="reset-template-confirm__button reset-template-confirm__button--primary"
          onClick={onConfirm}
          disabled={saving}
        >
          {saving ? 'Resetting...' : 'Reset and apply'}
        </button>
      </div>
    </div>
  </Dialog>
);

export default ResetTemplateConfirmDialog;
